import React, {useEffect, useState} from 'react'
import {Alert, CircularProgress, List, ListItem, ListItemText} from '@mui/material'
import WbModal from '../../../components/common/WbModal'
import checkinApi from '../../../services/api/checkin/checkinApi'

// The wording of every option, as a pupil will read it.
const optionText = option => option?.pupilText ?? option?.staffText ?? ''

export const optionSummary = question => {
  const options = question?.multiOptionResponseAttributes ?? []
  if (options.length === 0) return ''
  return [...options]
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map(optionText)
    .filter(Boolean)
    .join(' · ')
}

// Shows a template's questions, in the order the check-in will ask them, so
// an admin can read what pupils will be asked before choosing it.
export default function TemplatePreview({template, onClose}) {
  const [questions, setQuestions] = useState(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let cancelled = false
    setQuestions(null)
    setFailed(false)
    checkinApi
      .getTemplateQuestions(template.id)
      .then(res => {
        if (!cancelled) setQuestions(Array.isArray(res) ? res : [])
      })
      .catch(error => {
        console.error('Failed to load check-in template questions', error)
        if (!cancelled) setFailed(true)
      })
    return () => {
      cancelled = true
    }
  }, [template.id])

  let content
  if (failed) {
    content = (
      <Alert severity="error">
        We could not load this template's questions. Please try again.
      </Alert>
    )
  } else if (questions === null) {
    content = <CircularProgress />
  } else if (questions.length === 0) {
    content = <Alert severity="info">This template has no questions yet.</Alert>
  } else {
    content = (
      <List dense>
        {questions.map((question, index) => (
          <ListItem key={question.id ?? index} alignItems="flex-start">
            <ListItemText
              primary={`${index + 1}. ${question.pupilText ?? question.staffText ?? ''}`}
              secondary={optionSummary(question)}
            />
          </ListItem>
        ))}
      </List>
    )
  }

  return (
    <WbModal
      title={template.name}
      subtitle="Questions in the order the check-in will ask them"
      onClose={onClose}
      content={content}
    />
  )
}
